import { useMutation } from "react-query";
import { Purchase } from "types";
import { captureAddOnRestrictionErrors, clearAddOnRestrictionErrors } from "../helpers/PurchaseCreateHelpers";
import { api } from "@/api/api";
import { useSeller } from "@/hooks/useAccount";
import { CreatePurchaseState } from "@/stores/createPurchaseStore";

/** Creates the purchase on the first save and updates the draft after that. Each save reports its own limit errors. */
export const savePurchase = async (payload: CreatePurchaseState, params: Record<string, unknown>) => {
    clearAddOnRestrictionErrors();

    if (payload.id) {
        const { data } = await api.put<Purchase>(`/purchases/${payload.id}`, payload, { params });
        return data;
    }

    const { data } = await api.post<Purchase>("/purchases", payload, { params });
    return data;
};

export const useUpsertPurchase = () => {
    const seller = useSeller();

    return useMutation(async (payload: CreatePurchaseState) => savePurchase(payload, { seller: seller.id }), {
        onError: captureAddOnRestrictionErrors,
    });
};
